
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { dataSource_tonghao, dataSource_tonghao2 } from '@xt/client/dataSource/kindred-spirit'
import { Observer } from 'mobx-vue'
import MomentCard from './MomentCard.vue'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import { EnumTongHaoStatus, EnumTongHaoOtherStatus } from '@xt/client/enums/kindred-spirit'
import type { Moment } from '@xt/client/entities/kindred-spirit'
import { DairyOption, HomeworkOption } from '@xt/client/entities/course-v2/user-content'
import UserContentPop from '@xt/www/components/classhour/pop-content/index.vue'
import { Bind, Debounce } from 'lodash-decorators'
import lodash from 'lodash'

type QueryParams = {
  active: string
  otherParams: string
}

@Observer
@Component({
  components: {
    MomentCard,
    InfiniteLoading,
    UserContentPop
  },
  asyncData(ctx) {
    const queryParams = ctx.store.$tonghao.formatQuery(ctx.query)

    return {
      queryParams
    }
  }
})
export default class TonghaoPage extends Vue {
  queryParams: QueryParams

  requestTime: number = Date.now()

  @Ref()
  userContentPop: {
    showPop: (options: HomeworkOption | DairyOption) => void
    hidePop: () => void
  }

  get EnumTongHaoOtherStatus() {
    return EnumTongHaoOtherStatus
  }

  get EnumTongHaoStatus() {
    return EnumTongHaoStatus
  }

  get bodyParams() {
    let params: string[] = []
    Object.entries(this.queryParams).forEach(([key, value]) => {
      let title: string = ''

      if (key === 'active' && value !== '') {
        title = this.tabs.filter(el => el.key === value)[0]?.title
      }
      if (key === 'otherParams' && value !== '') {
        title = this.otherTabs.filter(el => el.key === value)[0]?.title
      }

      if (title) {
        // 排除-1，塞入其他选项
        // 1202 - ‘推荐’ 移除 ‘同学作品（7）’
        if (value === '-1') {
          params = this.tabs.filter(el => !(el.key === '-1' || el.key === '7')).map(el => el.title)
        } else {
          params.push(title)
        }
      }
    })

    return params.join(',')
  }

  get body() {
    console.log('bodyParams', this.bodyParams)

    return {
      firstRequestTime: this.requestTime,
      topics: this.bodyParams
    }
  }

  get pagePagination() {
    return this.PageStore.pagePagination
  }

  get UserStore() {
    return this.$store.$storeUser.UserInfo
  }

  get PageStore() {
    return this.$store.$tonghao
  }

  get otherTabs() {
    return dataSource_tonghao2
  }

  get tabs() {
    return dataSource_tonghao
  }

  handleOpenLogin() {
    this.userContentPop.hidePop()
    this.$store.$storeUser.onToggleVisible(true)
  }

  // 弹窗内部删除事件
  handleRemoveSuccess(data: { type: 'dairy'; momentId: string }) {
    if (data.type === 'dairy' && data.momentId) {
      // 删除缓存的数据
      this.PageStore.removeItem(data.momentId)
    }
  }

  // 弹窗内部收藏事件
  handleLikeSuccess(data: { momentId: string }) {
    if (data.momentId) {
      this.PageStore.likeItem(data.momentId)
    }
  }

  // 卡片点击事件
  handleClickMoment(momentId: string) {
    if (!momentId) return

    this.userContentPop?.showPop({
      type: 'dairy',
      momentId
    })
  }

  // 卡片点赞事件
  @Debounce(350, { leading: true, trailing: false })
  @Bind()
  async handleLikeMoment(item: Moment) {
    // 未登录防御
    if (!this.UserStore.id) {
      this.$store.$storeUser.onToggleVisible(true)
      return
    }

    try {
      await this.PageStore.onLikeMoment(item)
      this.$message.success('点赞成功')
    } catch (e) {
      if (e instanceof Error) {
        this.$message.error(e.message)
      }
    }
  }

  handleChangeTab(params: Partial<QueryParams>) {
    if (lodash.isEqual(this.queryParams, params)) return

    this.queryParams = {
      ...this.queryParams,
      ...params
    }

    // 切换tab数据清空 + 缓存
    this.PageStore.pagePagination.clearData(this.body)

    this.$router.replace({ query: this.PageStore.toSearchQuery(this.queryParams) })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
